import { villes1 } from "./villes1";
import { villes2 } from "./villes2";

export const villePages = [...villes1, ...villes2];
